export default __webpack_public_path__ + "static/gerald-6412d1e6d0b0758a4ab2c3db71dd74a3.png";